import { CatalogItem } from '@/pages/Catalog/types';
import { isBeforeWithOrder, PERIOD_TYPE_SORTING_ORDER } from '@/pages/Catalog/utils/sorts';

export const takeItemBasedOnOrder = (existing: CatalogItem, item: CatalogItem) => {
  if (Number(existing.TimeRef) < Number(item.TimeRef)) {
    return item;
  }
  if (Number(existing.TimeRef) === Number(item.TimeRef)) {
    const isPeriodTypeBefore = isBeforeWithOrder(
      item.PeriodType,
      existing.PeriodType,
      PERIOD_TYPE_SORTING_ORDER
    );
    if (isPeriodTypeBefore > 0) {
      return item;
    } else if (isPeriodTypeBefore === 0) {
      if (existing.Period > item.Period) {
        return item;
      }
    }
  }
  return existing;
};
